// Nextjs
import { NextPage } from 'next'

// Meta Tags
import MetaTags from '@/components/common/meta-tags'

// Hero BreadCrumb
import BreadCrumb from '@/components/common/breadcrumb'

// Page Components
import AboutHeroSection from '@/components/page-components/about-page/about-hero'
import WhyChooseUsSection from '@/components/page-components/about-page/why-choose-us'
import AboutContactInfo from '@/components/page-components/about-page/contact-info'

const AboutUsPage: NextPage = () => {
  return (
    <>
      <MetaTags title="About Comfort - The Home Craft" />

      <BreadCrumb pageName="About" />

      <AboutHeroSection />

      <WhyChooseUsSection />

      <AboutContactInfo />
    </>
  )
}

export default AboutUsPage
